import * as React from 'react';
import { Dispatch } from 'redux';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';

export class GenerateParticipantsZipRequest extends BaseApiPostRequest<{}, EntityNormalizers.NormalizedEntity<{}>> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super({}, component, dispatch);
    this.path = `/events/${eventId}/participants-zip`;
    this.normalizeMethod = result => result;
  }
}
